import { render, staticRenderFns } from "./CaseOrderForms.vue?vue&type=template&id=c5ec1446"
import script from "./CaseOrderForms.vue?vue&type=script&lang=js"
export * from "./CaseOrderForms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports